import { render } from "./submitted_under.vue?vue&type=template&id=47079482"
import script from "./submitted_under.vue?vue&type=script&lang=js"
export * from "./submitted_under.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__